import React, { Component, useState,useEffect } from 'react';
import { render } from 'react-dom';

import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from 'react-places-autocomplete';
import MapWithInfoBox from '../frontend/MapWithInfoBox';


const AdminAutoComplete = (props) => {

    const [address, setAddress] = useState("");
    const [coordinates, setCoordinates] = useState({ lat: null, long: null });

    console.log(props.addressLocation);

   // useEffect(() => {
       // setAddress(props.addressLocation.street_address && props.addressLocation.street_address !== undefined ? props.addressLocation.street_address : props.addressLocation.address)
   // }, []);

    useEffect(() => {
        if (props.addressLocation) {
            const existingAddress = props.addressLocation.address || props.addressLocation.street_address || "";
            setAddress(existingAddress);
        }
    }, [props.addressLocation]);


        
    const handleSelect = async value => {
        const results = await geocodeByAddress(value);
        const ll = await getLatLng(results[0]);
        setAddress(value);
        setCoordinates(ll);
        if(props.setCoodinationValueAddress) {
            props.setCoodinationValueAddress(results, ll);
        } else {
            props.setCoodinationValue(value, ll);
        }

        //console.log(value);
        //console.log(ll);
        //getSearchInput(value,ll);
    };

    if (MapWithInfoBox) {
        return (
            <PlacesAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={handleSelect}
            >
                {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading
                }) => (
                    <div
                        key={suggestions.description}
                    >
                        <input
                         style={{ width: "100%" }}
                            {...getInputProps({
                                placeholder: 'Location...',
                                className: 'location-search-input form-control',
                                'name': 'search_location'
                            })}
                        />
                        <span className="fa fa-map-marker heart-icon-post-listing errspan"></span>
                        <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map(suggestion => {
                                const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                    ? { backgroundColor: '#ffffff', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                return (


                                    <div id="infowindow-content"
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style
                                        })}
                                        key={suggestion.placeId}
                                    >
                                        <span className="place-address">{suggestion.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        )
    }
}

export default AdminAutoComplete